import { render, staticRenderFns } from "./TooltipDimensionierungErdungsanlage.vue?vue&type=template&id=2ca163e4&scoped=true&"
import script from "./TooltipDimensionierungErdungsanlage.vue?vue&type=script&lang=js&"
export * from "./TooltipDimensionierungErdungsanlage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca163e4",
  null
  
)

export default component.exports